<template>
    <div class="o-google-doc-link">
        <b-spinner v-if="isLoading" small ref="spinner" class="spinner"/>
        <a :disabled="isLoading" :href="url" v-on:click.prevent="clickHandler">
            {{ title }}
        </a>
    </div>
</template>

<script>

export default {
    name: 'OGoogleDocLink',
    components: {
    },
    props: {
        url: {
            type: String,
            required: true,
        },
        extrenalId: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
        onSetGoogleDocPermissions: {
            type: Function,
            required: true,
        }
    },
    data() {
        return {
            isLoading: false
        }
    },
    computed: {
    },
    methods: {
        async clickHandler() {
            this.isLoading = true;
            try {
                await this.onSetGoogleDocPermissions({
                    externalDocIds: [this.extrenalId]
                })
                window.open(this.url, '_blank');
                this.isLoading = false;
            } catch (err) {
                this.isLoading = false;
                throw err;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import 'theme';
</style>
